import { useState } from "react";

const tabs = [
    { id: "cam1", label: "All", width: 120, x: 0 },
    { id: "cam2", label: "Activate", width: 150, x: 120 },
    { id: "cam3", label: "Inactivate", width: 170, x: 280 }
];

const MapBtn = ({handleMapType}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const activeTab = tabs[activeIndex];

    return (
        <ul className="nav nav-pills nav-fill p-1 position-relative" role="tablist" style={{ listStyle: "none" }}>
            {tabs.map((tab, i) => (
                <li key={tab.id} className="nav-item" role="presentation">
                    <a
                        className={`nav-link mb-0 px-0 py-1 ${i === activeIndex ? "active" : ""}`}
                        data-bs-toggle="tab"
                        href={`#${tab.id}`}
                        role="tab"
                        aria-controls={tab.id}
                        aria-selected={i === activeIndex}
                        onClick={(e) => {
                            e.preventDefault();
                            setActiveIndex(i);
                            handleMapType(tabs[i]?.label);
                        }}
                    >
                        {tab.label}
                    </a>
                </li>
            ))}

            {/* moving underline/tab */}
            <div
                className="moving-tab position-absolute nav-link"
                style={{
                    padding: 0,
                    transition: "0.5s",
                    transform: `translate3d(${activeTab.x}px, 0, 0)`,
                    width: `${activeTab.width}px`
                }}
            >
                <a className="nav-link mb-0 px-0 py-1 active" href={`#${activeTab.id}`}>-</a>
            </div>
        </ul>
    );
}

export default MapBtn;
